<style scoped>
  .app {
    position: relative;
    width: 100%;
    max-width: 750px;
    min-width: 320px;
    margin: 0 auto;
    padding-top: 4.25rem;
    padding-bottom: 2.5rem;
    border-left: 1px solid #f2f2f2;
    border-right: 1px solid #f2f2f2;
  }

  .top {
    position: fixed;
    top: 0;
    z-index: 2;
    width: 100%;
    max-width: 750px;
    height: 2rem;
    line-height: 2rem;
    padding-left: 5px;
    background-color: white;
    border-bottom: 1px solid #ccc;
    box-shadow: 1px 1px 1px #ddd;
  }

  .market {
    position: fixed;
    top: 2rem;
    z-index: 1;
    height: 2.25rem;
    line-height: 2.25rem;
    background-color: white;
    width: 100%;
    max-width: 750px;
  }

  .market2 {
    z-index: 1;
    height: 2.25rem;
    line-height: 2.25rem;
    background-color: white;
    width: 100%;
    max-width: 750px;
  }

  .market span, .market2 span  {
    display: block;
    float: left;
    width: 20%;
    text-align: center;
    border-bottom: 1px solid #ccc;
  }

  .claecla {
    /* height: calc(100% - 4.25rem); */
    height: calc(100% + 3rem);
    padding-bottom: 20px;
  }

  .code {
    height: 2rem;
    max-height: 2rem;
    overflow: hidden;
    line-height: 2rem;
    width: 100%;
    border-bottom: 1px solid #eee;
  }

  .code span {
    color: #515a6e;
    display: block;
    float: left;
    width: 20%;
    text-align: center;

    border-bottom: 1px solid #eee;
  }

  .red {
    color: #e75563 ;
  }

  .green {
    color: #16d397 ;
  }

  .black {
    color: #000 !important;
  }

  .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .vertical-center-modal .ivu-modal {
    top: 0;
  }

  .modal-row {
    padding-bottom: 5px;
    margin-bottom: 5px;
    border-bottom: 1px solid #ccc;
    text-align: center;
    height: 3rem;
    line-height: 1rem;
  }

  .modal-row .sele-p {
    padding: 0 10px;
  }

  .modal-buy {
    padding: 5px;
    text-align: center;
    color: white;
    background-color: rgb(217, 84, 79);
    border-radius: 5px
  }

  .modal-sale {
    padding: 5px;
    text-align: center;
    color: white;
    background-color: rgb(91, 184, 93);
    border-radius: 5px
  }

  .del {
    text-decoration: line-through;
  }
  
</style>
<template>
  <div class="app">
    <Row class="top">
      <Col :xs="13" :sm="7" :class="headClass">
        <Icon type="md-menu" size="24"/>
        <!-- <span @click="drawerBtn = true">{{gsName}}</span> -->
        <span>{{companyAllName}}</span>
      </Col>
      <Col :xs="0" :sm="8">
        <Button @click="$router.push('/pdf')" v-if="environment == 0">
          <span>导出场外报价表</span>
        </Button>
        <!-- <Button @click="$router.push('/diff-pdf')" style="margin-left: 5px;">
          <span>导出价差报价表</span>
        </Button> -->
      </Col>
      <Col :xs="11" :sm="environment == 0 ? 9 : 17" style="padding-right:5px;text-align:right">
        <span @click="prompt">简易提示</span>
        <DatePicker style="width: 100px" size="small" type="date" format="yyyyMMdd" v-model="expiryDate"
          :options="options3" placeholder="Select date" placement="bottom-end" :clearable="false" :editable="false"
          @on-change="expiryDateChange">
        </DatePicker>
      </Col>
    </Row>
    <Drawer :title="gsName" placement="left" :closable="false" v-model="drawerBtn">
      <Row style="text-align: center">
        <div @click="loginSys">
          <Avatar icon="ios-person" size="large" />
          <p style="margin-top: 5px">{{username}}</p>
        </div>
      </Row>
    </Drawer>

    <!-- 期权报价 strat -->
    <Row class="market">
      <span>品种</span>
      <span>代码</span>
      <span>标的价格</span>
      <span @click="priceTypeChange"> {{ buyLabel }} </span>
      <span @click="priceTypeChange"> {{ saleLabel }} </span>
    </Row>
    <Row class="claecla">
      <Row class="code" v-for="(item, index) in newData" :key="index">
        <span>{{ item.name?item.name:'---'}}</span>
        <span @click="goTpage(item.market, item.code, changeDate(expiryDate), item)">{{ item.code }}</span>
        <span :class="{ red: item.call , green: !item.call, black: item.put, del: item.isDel }" @click="goTpage(item.market, item.code, expiryDate, item)">{{ item.price }}</span>
        <span :class="{ red: item.call , green: !item.call, black: item.put, del: item.isDel }" @click="detailedPrice(item.code, item.buy, item.isDel, changeDate(expiryDate))">{{ lessThan(item.buy, item) }}</span>
        <span :class="{ red: item.call , green: !item.call, black: item.put, del: item.isDel }" @click="detailedPrice(item.code, item.sale, item.isDel, changeDate(expiryDate))">{{ lessThan(item.sale, item) }}</span>
      </Row>
    </Row>
    <!-- 期权报价 end -->

    <!-- 价差报价 start -->
    <diffOffer :expiryDate="expiryDate" :nowDate="nowDate"></diffOffer>
    <!-- 价差报价 end  -->

    <Modal title="操作提示" v-model="modalPrompt" :footer-hide="true" class-name="vertical-center-modal">
      <p>点击代码和价格一栏进入T型报价</p>
      <p>点击买价和卖价一栏进入详细价格界面</p>
      <p>pc端建议打开F12进入手机浏览模式</p>
      <p v-if="sys">仿真环境左上角公司名称会变为淡红色, 测试环境颜色会变为深红色; (该条提示生产环境不可见)</p>
    </Modal>

    <Modal :title="Title" v-model="drawerModal" :footer-hide="true" class-name="vertical-center-modal">
      <Row>
        <Col span="12" class="modal-row">
        <p>挂钩标的</p>
        <p> {{ detailedData.code }} </p>
        </Col>
        <Col span="12" class="modal-row">
        <p>到期日期</p>
        <p>{{ changeDate(expiryDate) }}</p>
        </Col>
      </Row>
      <Row>
        <Col span="12" class="modal-row">
        <p>看涨看跌</p>
        <p class="sele-p">
          <Select v-model="direction" @on-change="priceChange(detailedData)">
            <Option v-for="item in optionDirection" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </p>
        </Col>
        <Col span="12" class="modal-row">
        <p>标的价格</p>
        <p class="sele-p">
          <InputNumber v-model="detailedData.thePrice" placeholder="0" @on-change="priceChange(detailedData)">
          </InputNumber>
        </p>
        </Col>
      </Row>
      <Row>
        <Col span="12" class="modal-row">
        <p>执行价</p>
        <p class="sele-p">
          <InputNumber v-model="detailedData.strikePrice" placeholder="0" @on-change="priceChange(detailedData)">
          </InputNumber>
        </p>
        </Col>
        <Col span="12" class="modal-row">
        <p>成交数量</p>
        <p class="sele-p">
          <!-- <InputNumber v-model="detailedData.volume" :max="detailedData.tradeMaxVolume" :min="detailedData.tradeMinVolume" placeholder="0" @on-change="numberChange"></InputNumber> -->
          <InputNumber v-model="detailedData.volume" :max="detailedData.tradeMaxVolume" placeholder="0" @on-change="numberChange" @on-blur="VolumeChange"></InputNumber>
        </p>
        </Col>
      </Row>
      <Row>
        <Col span="11" class="modal-buy">
          <div @click="detailedPriceBuy(detailedData, 'B')">
            <p> {{ lessThan(detailedData.salePrice) }} | {{ lessThan(detailedData.salePercent) }} </p>
            <p> 买入 </p>
            <p> {{ "vol:" + testpercent(detailedData.buyVol) }} </p>
          </div>
        </Col>
        <Col span="11" offset="2" class="modal-sale">
        <div @click="detailedPriceBuy(detailedData, 'S')">
          <p> {{ lessThan(detailedData.buyPrice) }} | {{ lessThan(detailedData.buyPercent) }} </p>
          <p> 卖出 </p>
          <p> {{ "vol:" + testpercent(detailedData.saleVol) }} </p>
        </div>
        </Col>
      </Row>
      <Row style="margin-top:5px;text-align:center">
        <Col span="11">
        <Alert>
          <p>{{ "权利金:" + detailedData.royalties }}</p>
        </Alert>
        </Col>
        <Col span="11" offset="2">
        <Alert>
          <p>{{ "保证金:" + detailedData.margin }}</p>
        </Alert>
        </Col>
      </Row>
    </Modal>
    <BottonTab :isShow="true" :currentday="nowDate" :daydiff="dayDiff"></BottonTab>

    <!-- 风险揭示书 -->
    <el-dialog :close-on-click-modal="false" title="风险揭示书" :visible.sync="dialogVisible" width="80%" :show-close="false"
      :close-on-press-escape="false"  >
      <el-input type="textarea" :rows="20" v-model="book" disabled>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
 
    <el-dialog :close-on-click-modal="false" title="请输入交易密码" :visible.sync="dialogOrder" :before-close="handlerClose" width="80%" @open="openPassDialog">
      <el-row>
        <el-col :span="8">交易密码:</el-col>
        <el-col :span="12">
          <el-input type="password" size="mini" v-model="tradePassword"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handlerClose">取消</el-button> 
        <el-button type="primary" size="mini" @click="enter">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import BottonTab from '@/components/BottonTab'
  import diffOffer from '@/components/home/diffHome'
  import global_ from '@/components/Global'
  import GlobalConfig from '@/components/Global.config.vue'
  import bus from '@/assets/eventBus'
  import axios from '@/axios'

  export default {
    data() {
      return {
        newData: [],
        CacheData: [],
        marketCode: [],
        drawerBtn: false,
        restDay: [],
        expiryDate: '',
        minDays: '',
        nowDate: '',
        options3: {
          disabledDate: date => {
            return date.getDay() === 0 || date.getDay() === 6 || this.changeDate(date) < this.minDays || this.$store
              .state.restDayStore.indexOf(Number(this.changeDate(date))) !== -1
          }
        },
        bid_deduction: '',
        ask_deduction: '',
        CodeList: [],
        FlatVolatility: {
          'vol': false,
          'pri': false
        },
        sucOrEee: false,
        Title: 'test',
        drawerModal: false,
        direction: 'C',
        optionDirection: [{
            value: 'C',
            label: '看涨'
          },
          {
            value: 'P',
            label: '看跌'
          }
        ],
        strikePrice: 0,
        modalPrompt: false,
        detailedData: {
          code: '',
          market: '',
          interestRate: '',
          thePrice: 0,
          strikePrice: 0,
          volume: 0,
          buyPrice: 0,
          salePrice: 0,
          buyVol: '',
          saleVol: '',
          buyPercent: '',
          salePercent: '',
          tradeMinVolume: 0,
          tradeMaxVolume: 0,
          marginRate: '',
          tradingMargin: '',
          delta: '',
          royalties: '',
          margin: '',
          priceAccuracy: '',
          specialMarginRate: '',
          marginType: '',
        },
        buyLabel: '买价',
        saleLabel: '卖价',
        daochuFlag: true,
        dialogVisible: false,
        book: '',
        nameOptions: [], //获取品种名称

        fluctuationTimer: null,

        orderData: {},      
        orderDirection: '',
        dialogOrder: false,
        tradePassword: '',
        dayDiff: null,     //交易日模式下开始日和结束如之间的间隔天数

        isTrade: true,    //  是否可交易, 用于下单交易时校验数据是否合规,不符合不可以下单   暂无用
        currentRow: {},

        companyAllName: '',     //公司全名
        environment: 0,     //公司标识,   默认南华为0
      }
    }, 
    components: {
      BottonTab,
      diffOffer
    },
    created: function () {
      this.getFestival() //节假日扣减天数
      this.morningGetCurrent()  //定时在早上请求新的交易日
      this.getEnvironment()       //获取环境配置

      this.getCurrentDate().then((nowDate) => {    //获取当前交易日
        this.nowDate = nowDate
        window.sessionStorage.setItem("nowDate", nowDate)
        this.getRestDay().then(() => { //获取节假日
          this.gainUnderlyingSocketUrl().then(() => {
            this.getCodeList() //获取代码表
          })
        })
      })

      let stateus = window.localStorage.getItem("stateus")
      let login = window.sessionStorage.getItem("login")
      if (!stateus && !login) {
        this.read()
      }
  
      if(login) {
        // this.setServerOptional()
      }

      let that = this
      //  tDefinedEvent bus总线从tPage传来打开详细价格界面
      
      bus.$on('tDefinedEvent', async function (msg) {

        if(!msg.from) {
          that.drawerModal = true
        }
        that.expiryDate = msg.expiryDate
        await that.expiryDateChange()
        that.direction = msg.direction
        that.detailedData.thePrice = msg.thePrice
        that.detailedData.strikePrice = msg.strikePrice
        that.Title = msg.code + 'C' + that.changeDate(that.expiryDate) + 'M' + msg.thePrice
        for (var i = 0; i < that.$store.state.codeListStore.length; i++) {
          if (msg.code === that.$store.state.codeListStore[i].code) {
            if (msg.strikePrice === '---') {
              return false
            }
            that.detailedData.code = msg.code
            that.detailedData.market = that.$store.state.codeListStore[i].market
            that.detailedData.interestRate = that.$store.state.codeListStore[i].interest_rate
            that.detailedData.volume = that.$store.state.codeListStore[i].trade_min_volume
            that.detailedData.tradeMinVolume = that.$store.state.codeListStore[i].trade_min_volume
            that.detailedData.tradeMaxVolume = that.$store.state.codeListStore[i].trade_max_volume
            that.detailedData.marginRate = that.$store.state.codeListStore[i].marginRate
            that.detailedData.specialMarginRate = that.$store.state.codeListStore[i].specialMarginRate
            that.detailedData.marginType = that.$store.state.codeListStore[i].marginType
            that.detailedData.priceAccuracy = that.$store.state.codeListStore[i].priceAccuracy
          }
        }
        that.detailedPrice(msg.code, msg.BS, false, msg.expiryDate, msg).then(() => {
          if(msg.from) {
            that.priceChange(that.detailedData).then(res => {
              setTimeout(() => {

                bus.$emit("detailed", res)
       
              }, 500)
              // bus.$emit("detailed", res)
            })
          } else {
            that.priceChange(that.detailedData)
          }
        })
        
      })
    },
    destroyed() {
      if (this.fluctuationTimer) {
        clearTimeout(this.fluctuationTimer)
        this.fluctuationTimer = null
      }
    },
    methods: {
      gainUnderlyingSocketUrl() {
        return this.getSocketBaseUrl().then(data => {
          global_.optionsQuoteServerMarket = this.mergeSocketUrl(data.wsQuoteUri)
          global_.SpreadOptionsQuoteServerMarket = this.mergeSocketUrl(data.wsQuoteArbitrageUri)
          global_.underlyingMarketDataServe = this.mergeSocketUrl(data.wsQuoteUri)
          global_.forwordTransactionServer = this.mergeSocketUrl(data.wsForwardUri)
          global_.companyName = data.companyName
          global_.system = data.environmentDescription
          global_.systemDescribe = `该环境为${global_.system}, 该环境中的操作不具备实际效应`

          window.sessionStorage.setItem("optionsQuoteServerMarket", global_.optionsQuoteServerMarket)
          window.sessionStorage.setItem("SpreadOptionsQuoteServerMarket", global_.SpreadOptionsQuoteServerMarket)
          window.sessionStorage.setItem("underlyingMarketDataServe", global_.underlyingMarketDataServe)
          window.sessionStorage.setItem("forwordTransactionServer", global_.forwordTransactionServer)
          window.sessionStorage.setItem("companyName", global_.companyName)
          window.sessionStorage.setItem("system", global_.system)
          window.sessionStorage.setItem("systemDescribe", global_.systemDescribe)

          bus.$emit("haveBaseData", true)

          let ico = data.iconUri
          window.sessionStorage.setItem("titleIco", ico)
          this.setIco(ico)
          let logoUrl = data.companyPictureUri
          window.sessionStorage.setItem("logoUrl", logoUrl)
          let title = document.getElementsByTagName("title")[0]
          title.innerHTML = data.companyName

          this.companyAllName = data.companyAllName
          

          return 
        })
      },
      getEnvironment() {
        axios.get("client/inner/environmentconfig/queryFirst.do").then(result => {
          if(result.data.success) {
            this.environment = result.data.EnvironmentConfig.environment
          }
        })
      },
      setIco(ico) {
        var link = document.getElementsByTagName("link")[0]
        link.href = ico
      },
      getCodeList() { //替换websocket的代码表请求
        axios.get("client/inner/quoteconfig/queryTradeAll.do").then(result => {
          let list = result.data.quoteConfigs
          let codeList = []
          this.newData = []
          list.forEach(item => {
            let obj = {
              id: item.id,
              market: item.exchange,
              code: item.instrument,
              deadline: this.timeFormat(new Date(Number(item.deadline))),
              interest_rate: item.interestRate,
              min_days: item.minDays,
              strike_price_change: item.strikePriceChange,
              strike_price_count: item.strikePriceCount,
              trade_max_volume: item.tradeMaxVolume,
              trade_min_volume: item.tradeMinVolume,
              marginType: item.marginType,
              marginRate: item.marginRate,
              specialMarginRate: item.specialMarginRate,    //特别保证金率
              yearSession: item.yearTradeDays,
              // buyCpsDays: item.askCompensateDay,       //方向不同反过来取
              // sellCpsDays: item.bidCompensateDay,      
              buyCpsDays: item.bidCompensateDay,
              sellCpsDays: item.askCompensateDay,
              subAccountNo: item.subAccountNo,
              name: item.productName,
              quoteEffectiveDate: item.quoteEffectiveDate,    //报价有效期
              priceAccuracy: item.priceAccuracy,    //期权价格精度
            }
            codeList.push(obj)
          })

          this.$store.dispatch('changeCodeList', codeList)
          let minDaysArr = []
          let arr = []
          
          for (let i = 0; i < codeList.length; i++) {
            let obj = {}
            obj['market'] = codeList[i].market
            obj['code'] = codeList[i].code
            arr.push(obj)
            let newObj = {}
            newObj['id'] = codeList[i].id
            newObj['market'] = codeList[i].market
            newObj['code'] = codeList[i].code
            newObj['name'] = codeList[i].name
            newObj['price'] = '--'
            newObj['buy'] = '--'
            newObj['sale'] = '--'
            newObj['strike_price_change'] = codeList[i].strike_price_change
            newObj['ask_volatility'] = ''
            newObj['bid_volatility'] = ''
            newObj['interest_rate'] = codeList[i].interest_rate
            newObj['marginType'] = codeList[i].marginType
            newObj['marginRate'] = codeList[i].marginRate
            newObj['specialMarginRate'] = codeList[i].specialMarginRate
            // 新增年交易日数计算和买卖补偿天数、子账、保证金类型、品种名称、特别保证金率
            newObj["yearSession"] = codeList[i].yearSession ? codeList[i].yearSession : 365 //年交易日数为0时为365天
            newObj["buyCpsDays"] = codeList[i].buyCpsDays ? codeList[i].buyCpsDays : 0 //买补偿天数      
            newObj["sellCpsDays"] = codeList[i].sellCpsDays ? codeList[i].sellCpsDays : 0 //卖补偿天数
            newObj["subAccountNo"] = codeList[i].subAccountNo
            newObj["quoteEffectiveDate"] = codeList[i].quoteEffectiveDate   //获取报价有效期
            newObj["priceAccuracy"] = codeList[i].priceAccuracy   //期权价格精度
            newObj["preSettlePrice"] = ''   //前结算价

            // 检测报价有效期是否过期, 过期显示中间穿过线
            let current = new Date(Number(this.timeFormat(new Date(codeList[i].quoteEffectiveDate)))).getTime()
            let now = new Date(Number(this.nowDate)).getTime()
            if(current < now) {
              newObj["isDel"] = true
              
            } else {
              newObj["isDel"] = false
            }

            // if (Math.floor(Math.random() * 2) === 0) {
            //   newObj['call'] = true
            //   newObj['put'] = false
            // } else {
            //   newObj['call'] = false
            //   newObj['put'] = true
            // }
            minDaysArr.push(codeList[i].min_days)
            this.newData.push(newObj)
          }

          // let _this = this
          let that = this
          // 声明公共函数

          function OptionsQuoteSessionCodeList(url) {
            let _this = this
            this.out_going_queue = []
            this.connection = null
            this.is_open = function () {
              return this.connection.readyState === WebSocket.OPEN
            }
            this.send = function (parcel) {
              let data = JSON.stringify(parcel)
              if (this.is_open()) {
                this.connection.send(data)
                return true
              } else {
                return false
              }
            }
            this.flush = function () {}

            function onOpen(evt) {
              _this.codeinfo()
              _this.jichushujv()
              _this.dingyue()
            }

            function onClose(evt) {
              setTimeout(function () {
                _this.reconnect()
              }, 10000)
            }

            function onError(evt) {}

            function heartbeat() {
              setInterval(() => {
                if(_this.connection.readyState !== 1) return
                _this.connection.send(JSON.stringify({messageType: "HEARTBEAT"}))
              }, 50000)
              
            }

            this.reconnect = function () {
              this.connection = new WebSocket(url)
              this.connection.onopen = onOpen
              this.connection.onclose = onClose
              this.connection.onmessage = onMessage
              this.connection.onerror = onError
            }
            this.codeinfo = function () {     //代码表
              let queryCodeInfoReqPack = makeParcel(GlobalConfig.optionType.request.requestCodeInfo, {
                'code_list': that.marketCode
              })
              if (!this.send(queryCodeInfoReqPack)) {
                return false
              }
            }
            this.jichushujv = function () {     //初始化行情
              let queryCodeInfoReqPack = makeParcel(GlobalConfig.optionType.request.requestMarket, {
                'code_list': that.marketCode
              })
              if (!this.send(queryCodeInfoReqPack)) {
                return false
              }
            }
            this.dingyue = function () {      //行情推送
              let queryCodeInfoReqPack = makeParcel(GlobalConfig.optionType.push.pushMarket, {
                'code_list': that.marketCode
              })
              if (!this.send(queryCodeInfoReqPack)) {
                return false
              }
            }

            function onMessage(evt) {
              let parcel = JSON.parse(evt.data)
              switch (parcel.messageType) {
                case GlobalConfig.optionType.response.initMarket:          //获取初始化行情相关
                  heartbeat()
                  that.CacheData = JSON.parse(evt.data).messageData.market_data
                  that.$store.dispatch('changeCacnhe', that.CacheData)
                  that.FlatVolatility.pri = true
                  that.sucOrEee = true
                  for (let i = 0; i < that.newData.length; i++) {
                    for(let j=0;j<parcel.messageData.market_data.length; j++) {
                      if(that.newData[i].market == parcel.messageData.market_data[j].exchange_id && that.newData[i].code == parcel.messageData.market_data[j].instrument_id) {
                        let newPrice = parcel.messageData.market_data[j].last_price?parcel.messageData.market_data[j].last_price:parcel.messageData.market_data[j].pre_close_price
                        let settlePrice = parcel.messageData.market_data[j].settlePrice?parcel.messageData.market_data[j].settlePrice:parcel.messageData.market_data[j].pre_close_price
                        let priceAccuracy = that.newData[i].priceAccuracy
                        that.newData[i].price = Number(newPrice.toFixed(priceAccuracy))
                        that.newData[i].preSettlePrice = Number(settlePrice.toFixed(priceAccuracy))
                      }
                    }
                  }
                  break
                case GlobalConfig.optionType.response.pushType:         //获取行情推送
                  let ThisData = JSON.parse(evt.data)
                  for (let j = 0; j < that.CacheData.length; j++) {
                    if (that.CacheData[j].instrument_id === ThisData.messageData.market_data[0].instrument_id) {
                      let newPrice = ThisData.messageData.market_data[0].last_price?ThisData.messageData.market_data[0].last_price:ThisData.messageData.market_data[0].pre_close_price
                      that.CacheData[j].last_price = Number(newPrice.toFixed(2))
                    }
                  }
                  that.$store.dispatch('changeCacnhe', that.CacheData)
                  break
                case GlobalConfig.optionType.response.initCodeInfo:        //获取代码表
                  // for (let z = 0; z < that.newData.length; z++) {
                    // that.newData[z].name = that.zifuchan(parcel.messageData.instrument[z].instrument_name)
                    // that.newData[z].name = parcel.messageData.instrument[z].product_id
                  // }
                  that.$store.dispatch('changeInstrument', parcel.messageData.instrument)
                  break
                default:
                  break
              }
              that.getNewPriceFun()
            }
          }

          function Parcel(msgType, body) {
            // this.f = msgType
            // this.r = GlobalConfig.generate_rid()
            this.messageType = msgType
            if (body) {
              // this.b = body
              this.messageData = body
            } else {
              this.b = {}
            }
          }

          function makeParcel(msgType, body) {
            let p = new Parcel(msgType, body)
            return p
          }
          let optionsQuote = {
            'kOutQueryCodeInfoReq': 257,
            'kOutQueryCodeInfoResp': 33025,
            'kOutQueryVolatilityReq': 265,
            'kOutQueryVolatilityResp': 33033,
            'kOutQueryFestivalReq': 259,
            'kOutQueryFestivalResp': 33027,
            'kOutQueryTradingDayReq': 260,
            'kOutQueryTradingDayResp': 33028,
            'kOutQueryMarketCodeReq': 513,
            'kOutQueryMarketCodeResp': 33281,
            'kOutQueryHangQingReq': 514,
            'kOutQueryHangQingResp': 33282,
            'kOutQueryDingYueReq': 515,
            'kOutQueryDingYueResp': 33283
          }
          this.marketCode = arr
          let mindays = Math.min.apply(Math, minDaysArr)
          let DayArr = this.ThirdDate(this.restDay, 30)
          this.expiryDate = DayArr[0]
          // this.nowDate = DayArr[2]
          let DayArrMin = this.ThirdDate(this.restDay, mindays)
          this.minDays = DayArrMin[0]
          let locaOpArr = JSON.parse(localStorage.getItem('optionalCode')) || []
          for (var i = 0; i < locaOpArr.length; i++) {
            if (locaOpArr[i].opExpiryDate < this.expiryDate) {
              locaOpArr.splice(i, 1)
              i--
            } else {}
          }
          this.getDiff().then(day => {
            this.dayDiff = day
            this.fluctuation() //获取波动度
          })

          let optionsQuoteServerMarket = global_.optionsQuoteServerMarket
          // let optionsQuoteServer = global_.optionsQuoteServer
          localStorage.setItem('optionalCode', JSON.stringify(locaOpArr))
          this.$store.dispatch('changeOptional', locaOpArr)

          let optionsQuoteSesseionJichu = new OptionsQuoteSessionCodeList(optionsQuoteServerMarket)
          optionsQuoteSesseionJichu.reconnect()
          // let optionsQuoteSesseion = new OptionsQuoteSession(optionsQuoteServer)
          // optionsQuoteSesseion.reconnect()


          //  每过3秒刷新一次最新报价
          setInterval(() => {
            if (this.FlatVolatility.vol && this.FlatVolatility.pri) {
              this.FlatVolatility.vol = false
              this.$Loading.finish()
              return false
            }
            this.getNewPriceFun()
          }, 10000)
        })
      },

      getRestDay() { //获取节假日
        return new Promise((reslove, reject) => {
          axios.get("client/inner/festivalconfig/queryFestivalList.do").then(result => {
            let restDays = JSON.parse(result.data.festivalConfig).exchange_rest_day[0].rest_day
            this.restDay = restDays
            this.$store.dispatch('changeRestDate', this.restDay)
            reslove()
          })
        })
      },
      getFestival() { //节假日扣减天数
        return new Promise((reslove, reject) => {
          axios.get("client/inner/festivalconfig/queryAll.do").then(result => {
            if (result.data.success) {
              let data = result.data.festivalConfigs
              let arr = []
              data.forEach(item => {
                let obj = {
                  ask_deduction: item.askDeduction,
                  bid_deduction: item.bidDeduction,
                  business_type: item.businessType,
                  festival_date: this.timeFormat(new Date(item.festivalDate)),
                  id: item.id,
                }
                arr.push(obj)
              })
              this.festivalList = arr
              this.$store.dispatch('changeFestList', this.festivalList)
            
              let dce = this.Deduction(this.timeFormat(), this.expiryDate, this.festivalList)
              this.bid_deduction = dce[0]
              this.ask_deduction = dce[1]
            }
          })
        })
      },
      fluctuation() { //获取全部波动度
        return new Promise((reslove, reject) => {
          axios.post("client/inner/quoteconfig/getTradeVolatilityVOList.do", this.qs.stringify({
            expiringDate: this.expiryDate,
          })).then(result => {
            if (result.data.success) {
              let data = result.data.tvs
              this.FlatVolatility.vol = true
              this.sucOrEee = true
              for (let j = 0; j < data.length; j++) {
                if (data.length) {
                  this.newData[j].ask_volatility = data[j].askVolatility
                  this.newData[j].bid_volatility = data[j].bidVolatility
                } else {
                  this.newData[j].ask_volatility = ''
                  this.newData[j].bid_volatility = '' 
                }
              }
              reslove()
              this.fluctuationTimer = setTimeout(() => {
                this.fluctuation()
              }, 300000);
              this.getNewPriceFun()
            }
          })
        })
      },
      fluctuationOnlyOne(exchange, underlying, expiringDate, lastPrice, strikePrice, subAccountNo) { //获取单个的买卖波动度
        return new Promise((reslove, reject) => {
          axios.post("client/inner/quoteconfig/getTradeVolatilityVO.do", this.qs.stringify({
            exchange,
            underlying,
            lastPrice,
            strikePrice,
            expiringDate,
            subAccountNo,
          })).then(result => {
            if (result.data.success) {
              reslove(result.data.tradeVolatilityVO)
            } else {
              reslove([])
            }
          })
        })
      },

      nightGetCounting() {   //在页面开始加载时启动定时器, 在晚上七点到九点查询夜盘的交易日
        if(new Date().getDay() == 6 || new Date().getDay() == 0) return   //周六日不用拉
        let end = this.getAccuracy('19:0:0')
        if(end < Date.now() && this.nowDate == this.timeFormat()) {      //如果是打开界面时间为7点以后且交易日还等于今天, 默认直接启动定时器
          this.nightLoopCurrentDate()
          return
        }
        let msec = this.timeDiff(end)
        setTimeout(() => {
          this.nightLoopCurrentDate()
        }, msec)
      },
      nightLoopCurrentDate() {
        this.getCurrentDate().then(nowDate => {
          let nine = this.getAccuracy('21:0:0')
          if(Date.now() > nine) {
            return
          }
          if(nowDate === this.nowDate) {
            setTimeout(() => {
              this.nightLoopCurrentDate()
            }, 300000)
          } else {
            this.nowDate = nowDate
            this.getCodeList()
          }
        })
        
      },
      morningGetCurrent() {
        if(new Date().getDay() == 6 || new Date().getDay() == 0) return   //周六日不用拉
        let begin = this.getAccuracy('7:0:0')
        let end = this.getAccuracy('9:0:0')
        let current = Date.now()
        if(current > end) {       //如果是九点打开界面以后就不用在请求了,设置晚上的定时器
          this.nightGetCounting()  //在晚上七点到九点查询夜盘的交易日
          return
        }    
        if(current < end && current >= begin) {     //7点到9点
          this.morningLoopCurrentDate()
          return
        }
        if(current < begin) {
          let msec = this.timeDiff(current, begin)
          setTimeout(() => {
            this.morningLoopCurrentDate()
          }, msec)
        }
      },
      morningLoopCurrentDate() {
        this.getCurrentDate().then(nowDate => {
          let end = this.getAccuracy('9:0:0')
          if(Date.now() > end) {
            this.nightGetCounting()  //在晚上七点到九点查询夜盘的交易日
            return
          }
          if(nowDate == this.timeFormat()) {    //早上请求过来的交易日等于今天, 停止请求
            this.nightGetCounting()  //在晚上七点到九点查询夜盘的交易日
            this.nowDate = nowDate
            return
          }
          if(nowDate === this.nowDate) {
            setTimeout(() => {
              this.morningLoopCurrentDate()
            }, 300000)
          } else {
            this.nowDate = nowDate
            this.nightGetCounting()  //在晚上七点到九点查询夜盘的交易日
            this.getCodeList()
          }
        })
      },

      getInfo() {
        axios.post('client/queryClientBaseInfo.do').then(result => {
          if (result.data.success) {
            this.$store.commit('changeUserName', result.data.client.username)
          }
        })
      },
      handleStart() {
        this.$Modal.info({
          title: 'Bravo',
          content: 'Now, enjoy the convenience of iView.'
        })
      },
      bottom() {

      },
      async  expiryDateChange() {
        await this.getDiff().then(day => {
          
          this.dayDiff = day
          this.fluctuation()
        })

      },
      goTpage: function (m, c, e, item) {
        if(item.isDel) {
          this.$Message.warning("所有带有删除线的报价表示该报价还未被交易员确认")
          return
        }
        if(item.price == '---' || !item.price) return
        let date = this.changeDate(e)
        this.$router.push({
          path: '/TPage',
          name: 'TPageHome',
          params: {
            market: m,
            code: c,
            expiryDate: date,
            nowDate: this.nowDate,
            yearSession: item.yearSession,
            buyCpsDays: item.buyCpsDays,
            sellCpsDays: item.sellCpsDays,
            subAccountNo: item.subAccountNo,
          }
        })
      },
      detailedPrice: function (c, p, isDel, expiryDate, msg) {   //tBus代表是否是Tpage界面传过来的值, 默认为undefind
        return new Promise((reslove, reject) => {
          if(p == 'NaN' || p == 'NaN%' || p == '0.00%' || p == '---' || p <= 0) return
          if(isDel) {
            this.$Message.warning("所有带有删除线的报价证明该报价还未进行确认")
            return
          }
          let direction = msg?msg.direction:'C'
          let marginRate = 0
          let marginType = 0
          let specialMarginRate = 0
          this.direction = direction
          for (var i = 0; i < this.newData.length; i++) {
            if (c === this.newData[i].code) {
              this.currentRow = this.newData[i]
              if (this.newData[i].buy === '---' && this.newData[i].sale === '---') {
                bus.$emit("detailed", false)
                return false
              }
              // salePrice
              if(this.newData[i].yearSession == 0 || this.newData[i].yearSession == 365) {
                var dateNum = this.DateDiff(this.nowDate, this.changeDate(expiryDate), this.newData[i].buyCpsDays, this.newData[i].sellCpsDays)
              } else {
                if(!this.dayDiff) {
                  this.getDiff().then(day => {
                    var dateNum = [day + this.newData[i].buyCpsDays, day + this.newData[i].sellCpsDays]
                  })
                } else {
                  var dateNum = [this.dayDiff + this.newData[i].buyCpsDays, this.dayDiff + this.newData[i].sellCpsDays]
                }
              }
              if(!dateNum) dateNum = [0,0]
              let bidDeduction = this.bid_deduction
              let askDeduction = this.ask_deduction

              if(this.newData[i].yearSession == 365 || this.newData[i].yearSession == 0) {
                var dtBuy = this.division(this.sub(dateNum[0], bidDeduction), 365)
                var dtSale = this.division(this.sub(dateNum[1], askDeduction), 365)
              } else {
                var dtBuy = this.division(dateNum[0], this.newData[i].yearSession)
                var dtSale = this.division(dateNum[1], this.newData[i].yearSession)
              }

              marginRate = this.newData[i].marginRate
              marginType = this.newData[i].marginType
              specialMarginRate = this.newData[i].specialMarginRate
              let priceAccuracy = this.newData[i].priceAccuracy

              this.detailedData.code = c
              this.detailedData.market = this.newData[i].market
              this.detailedData.interestRate = this.newData[i].interest_rate
              //2022-05-19修复最新价 被覆盖的问题
              //this.detailedData.thePrice = this.newData[i].price
              this.detailedData.strikePrice = msg?msg.strikePrice:this.newData[i].price
              this.detailedData.buyVol = this.newData[i].bid_volatility
              this.detailedData.saleVol = this.newData[i].ask_volatility
              this.detailedData.priceAccuracy = priceAccuracy
              this.detailedData.marginType = marginType
              this.detailedData.specialMarginRate = specialMarginRate
        
              this.detailedData.salePrice = this.CalcCall(this.newData[i].price, this.newData[i].bid_volatility, this.newData[i].interest_rate, this.newData[i].price, dtBuy).toFixed(priceAccuracy)
              this.detailedData.buyPrice = this.CalcCall(this.newData[i].price, this.newData[i].ask_volatility, this.newData[i].interest_rate, this.newData[i].price, dtSale).toFixed(priceAccuracy)
    
              // this.detailedData.salePrice = this.CalcCall(this.newData[i].price, this.newData[i].bid_volatility, this.newData[i].interest_rate, this.detailedData.strikePrice, dtBuy).toFixed(2)
              // this.detailedData.buyPrice = this.CalcCall(this.newData[i].price, this.newData[i].ask_volatility, this.newData[i].interest_rate, this.detailedData.strikePrice, dtSale).toFixed(2)

              this.detailedData.buyPercent = this.mul(this.division(this.detailedData.buyPrice, this.newData[i].price), 100).toFixed(3) + '%'
              this.detailedData.salePercent = this.mul(this.division(this.detailedData.salePrice, this.newData[i].price), 100).toFixed(3) + '%'
              
              // this.detailedData.buyVol = this.newData[i].ask_volatility
              // this.detailedData.saleVol = this.newData[i].bid_volatility

              this.detailedData.volume = this.$store.state.codeListStore[i].trade_min_volume
              this.detailedData.tradeMinVolume = this.$store.state.codeListStore[i].trade_min_volume
              this.detailedData.tradeMaxVolume = this.$store.state.codeListStore[i].trade_max_volume
              this.detailedData.marginRate = this.$store.state.codeListStore[i].marginRate
              // 新增年交易日数和买卖补偿天数
              this.detailedData.yearSession = this.newData[i].yearSession
              this.detailedData.buyCpsDays = this.newData[i].buyCpsDays
              this.detailedData.sellCpsDays = this.newData[i].sellCpsDays
              this.detailedData.subAccountNo = this.newData[i].subAccountNo
              this.Title = this.newData[i].code + direction + this.changeDate(expiryDate) + 'M' + this.detailedData.strikePrice
              
              if(!msg || !msg.from) {
                this.drawerModal = true 
              }
            }
          }

          this.detailedData.tradingMargin = this.mul(this.detailedData.thePrice, this.detailedData.volume)
          this.detailedData.tradingMargin = this.mul(this.detailedData.tradingMargin, this.detailedData.marginRate)
          this.detailedData.delta = this.CalcCallDelta(this.detailedData.thePrice, this.detailedData.saleVol, 0.06, this.detailedData.strikePrice, dtSale)
          // this.detailedData.delta = this.detailedData.delta.toFixed(6)

          // var VirtualValue = Math.max(this.sub(this.detailedData.thePrice, this.detailedData.strikePrice), 0),
          //   VirtualValue = this.mul(VirtualValue, this.detailedData.volume);

          this.detailedData.royalties = this.mul(this.detailedData.salePrice, this.detailedData.volume)
          // this.detailedData.margin = this.mul(this.detailedData.tradingMargin, Math.max(this.detailedData.delta, 0.2))
          // this.detailedData.margin = Math.max(this.sub(this.detailedData.tradingMargin, (this.mul(0.5, VirtualValue))),
          //   (this.mul(0.5, VirtualValue)));
          this.detailedData.margin = this.calcMargin(this.detailedData.thePrice, this.detailedData.strikePrice, this.detailedData.salePrice, this.detailedData.buyPrice, this.detailedData.volume, marginRate, specialMarginRate, marginType, direction, this.detailedData.delta)
          reslove()
        })

      },

      priceChange(data) {
        return new Promise((reslove, reject) => {
          this.Title = this.detailedData.code + this.direction + this.changeDate(this.expiryDate) + 'M' + this.detailedData.strikePrice
          if (this.detailedData.strikePrice === '---') {
            return false
          }
          // 交易日报价不扣减, 补偿天数都要补偿
          if(data.yearSession == 0 || data.yearSession == 365) {
            var dateNum = this.DateDiff(this.nowDate, this.changeDate(this.expiryDate), data.buyCpsDays, data.sellCpsDays)
          } else {

            if(!this.dayDiff) {
              this.getDiff().then(day => {
                var dateNum = [day + data.buyCpsDays, day + data.sellCpsDays]
              })
            } else {
              var dateNum = [this.dayDiff + data.buyCpsDays, this.dayDiff + data.sellCpsDays]
            }
          }
          if(!dateNum) dateNum = [0,0]
          let bidDeduction = this.bid_deduction
          let askDeduction = this.ask_deduction
          if(data.yearSession == 365 || data.yearSession == 0) {
            var dtBuy = this.division(this.sub(dateNum[0], bidDeduction), 365)
            var dtSale = this.division(this.sub(dateNum[1], askDeduction), 365)
          } else {
            var dtBuy = this.division(dateNum[0], data.yearSession)
            var dtSale = this.division(dateNum[1], data.yearSession)
          }
          
          this.detailedData.tradingMargin = this.mul(this.detailedData.thePrice, this.detailedData.volume)
          this.detailedData.tradingMargin = this.mul(this.detailedData.tradingMargin, this.detailedData.marginRate)
          let strikePriceRatio = []
          let spr = Number(this.division(this.detailedData.strikePrice, this.detailedData.thePrice).toFixed(8))
          strikePriceRatio.push(spr)
          let that = this 
          let arr = []
          let obj = {}
          obj['market'] = that.detailedData.market
          obj['code'] = that.detailedData.code
          obj['expiring_date'] = that.changeDate(that.expiryDate)
          obj['strike_price_ratio'] = strikePriceRatio
          arr.push(obj)
          // let websockObj = {}
          // websockObj['f'] = 265
          // websockObj['r'] = that.generateRid()
          // websockObj['b'] = {}
          // websockObj.b['query_list'] = arr

          // that.websock.send(JSON.stringify(websockObj))
          // that.websock.onmessage = function (evt) {
          //   if (JSON.parse(evt.data).b.ret !== 0) {
          //     return false
          //   }
          var volatilityList = [] //买卖波动度
          // 所需参数交易所，标的代码，到期日，标的价格，执行价
          if(!this.detailedData.strikePrice || this.detailedData.strikePrice <= 0) {
            this.$message({
              type:'error',
              message: '执行价不能为空, 且必须大于0',
              showClose: true,
            })
            this.isTrade = false   //用于设置该数据不合规, 不能进行下单操作
            return
          }
          
          this.fluctuationOnlyOne(obj.market, obj.code, obj.expiring_date, this.detailedData.thePrice, this.detailedData.strikePrice, this.detailedData.subAccountNo).then((result => {
            this.isTrade = true
            let obj = {
              ask_volatility: [result.askVolatility],
              bid_volatility: [result.bidVolatility],
              code: result.underlying,
              expiring_date: result.expiringDate,
              market: result.exchange,
            }
            volatilityList = [obj]

            let askVolatility = volatilityList[0].ask_volatility[0]
            let bidVolatility = volatilityList[0].bid_volatility[0]
            let priceAccuracy = this.detailedData.priceAccuracy

            if (askVolatility === 0 && bidVolatility === 0) {
              that.detailedData.salePrice = '---'
              that.detailedData.buyPrice = '---'
              that.detailedData.buyPercent = '---%'
              that.detailedData.salePercent = '---%'
              that.detailedData.royalties = '---'
              that.detailedData.margin = '---'
              that.detailedData.buyVol = '---'
              that.detailedData.saleVol = '---'
              return false
            }

            if (that.direction === 'C') {
              that.detailedData.salePrice = that.CalcCall(that.detailedData.thePrice, bidVolatility, that.detailedData.interestRate, that.detailedData.strikePrice, dtBuy).toFixed(priceAccuracy)
              that.detailedData.buyPrice = that.CalcCall(that.detailedData.thePrice, askVolatility, that.detailedData.interestRate, that.detailedData.strikePrice, dtSale).toFixed(priceAccuracy)
              that.detailedData.delta = that.CalcCallDelta(that.detailedData.thePrice, askVolatility, that.detailedData.interestRate, that.detailedData.strikePrice, dtSale)
              // that.detailedData.delta = that.detailedData.delta.toFixed(6)
              var VirtualValue = Math.max(that.sub(that.detailedData.thePrice, that.detailedData.strikePrice), 0),
                VirtualValue = that.mul(VirtualValue, that.detailedData.volume);
            } else {
       
              that.detailedData.salePrice = that.CalcPut(that.detailedData.thePrice, bidVolatility, that
                .detailedData
                .interestRate, that.detailedData.strikePrice, dtBuy).toFixed(priceAccuracy)
              that.detailedData.buyPrice = that.CalcPut(that.detailedData.thePrice, askVolatility, that.detailedData
                .interestRate, that.detailedData.strikePrice, dtSale).toFixed(priceAccuracy)
              that.detailedData.delta = that.CalcPutDalta(that.detailedData.thePrice, askVolatility, that
                .detailedData
                .interestRate, that.detailedData.strikePrice, dtSale)
              // that.detailedData.delta = that.detailedData.delta.toFixed(6)

              var VirtualValue = Math.max(that.sub(that.detailedData.strikePrice, that.detailedData.thePrice), 0),
                VirtualValue = that.mul(VirtualValue, that.detailedData.volume);
              // console.log("--------------");
              // console.log("price:"+that.detailedData.thePrice);
              // console.log("bid_volatility:"+bidVolatility);
              // console.log("ask_volatility:"+askVolatility);
              // console.log("interest_rate:"+that.detailedData.interestRate);
              // console.log("price:"+that.detailedData.strikePrice);
              // console.log("dtBuy:"+dtBuy);
              // console.log("dtBuy:"+dtSale);
              // console.log("buyPrice"+ that.detailedData.buyPrice);
              // console.log("salePrice"+ that.detailedData.salePrice);
            }
            that.detailedData.buyPercent = this.mul(this.division(that.detailedData.buyPrice, that.detailedData.thePrice), 100)
              .toFixed(3) + '%'
            that.detailedData.salePercent = this.mul(this.division(that.detailedData.salePrice, that.detailedData.thePrice), 100)
              .toFixed(3) + '%'
            that.detailedData.buyVol = bidVolatility
            that.detailedData.saleVol = askVolatility
            that.detailedData.royalties = that.mul(that.detailedData.salePrice, that.detailedData.volume)

            // that.detailedData.margin = that.mul(that.detailedData.tradingMargin, Math.max(that.detailedData.delta, 0.2)).toFixed(2)
            // that.detailedData.margin = Math.max(that.sub(that.detailedData.tradingMargin, (that.mul(0.5, VirtualValue))), (that.mul(0.5, VirtualValue)));
            this.detailedData.margin = this.calcMargin(this.detailedData.thePrice, this.detailedData.strikePrice, this.detailedData.salePrice, this.detailedData.buyPrice, this.detailedData.volume, data.marginRate, data.specialMarginRate, data.marginType, this.direction, this.detailedData.delta)
            // }
          }))
          reslove(this.detailedData)
        })
        
      },
      numberChange: function () {
        this.detailedData.tradingMargin = this.mul(this.detailedData.thePrice, this.detailedData.volume)
        this.detailedData.tradingMargin = this.mul(this.detailedData.tradingMargin, this.detailedData.marginRate)
        this.detailedData.royalties = this.mul(this.detailedData.salePrice, this.detailedData.volume)
        // this.detailedData.margin = this.mul(this.detailedData.tradingMargin, Math.max(this.detailedData.delta, 0.2)).toFixed(2)
        var VirtualValue = Math.max(this.sub(this.detailedData.thePrice, this.detailedData.strikePrice), 0)
          VirtualValue = this.mul(VirtualValue, this.detailedData.volume);
        // this.detailedData.margin = Math.max(this.sub(this.detailedData.tradingMargin, (this.mul(0.5, VirtualValue))), (this.mul(0.5, VirtualValue)));
        
        this.detailedData.margin = this.calcMargin(this.detailedData.thePrice, this.detailedData.strikePrice, this.detailedData.salePrice, this.detailedData.buyPrice, this.detailedData.volume, this.currentRow.marginRate, this.currentRow.specialMarginRate, this.currentRow.marginType, this.direction, this.detailedData.delta)
      },
      VolumeChange() {
        if(this.detailedData.volume < this.detailedData.tradeMinVolume) {
          // this.detailedData.volume = this.detailedData.tradeMinVolume
          this.$message({
            type:'error',
            message: '不能小于最小下单量' + this.detailedData.tradeMinVolume ,
            showClose: true,
          })
          this.numberChange()
        }
      },
      detailedPriceBuy(obj, direction) {
        this.$Message.error('暂不支持交易')
        return      //暂时不支持交易
        this.orderData = obj
        this.orderDirection = direction

        // if(!this.userID) {
        //   this.$router.push('/Login')
        //   this.$message({
        //     type:'warning', 
        //     message: '检查到您还未登录,请先登录',
        //     showClose: true,
        //   })
        //   return
        // }

        let tradePassword = window.sessionStorage.getItem("tradePassword")
        if(!tradePassword) {
          this.dialogOrder = true
          return 
        }

        this.optionOrder(obj, direction)

      },
      optionOrder(obj = this.orderData, direction = this.orderDirection) {
        if(this.tradePassword === '') {
          this.$message({
            type:'error', 
            message: '请重新输入交易密码',
            showClose: true
          })
          this.dialogOrder = true
          return
        }
        let data = {
          clientBindId: this.userID,
          exchange: obj.market,
          contractCode: this.Title,
          underlying: obj.code,
          expiringDate: this.expiryDate,
          optionsType: 0,
          callPut: this.direction,
          underlyingPrice: obj.thePrice,
          strikePrice: obj.strikePrice,
          volume: obj.volume,
          buySell: direction,
          openClose: 'O',
          premium: obj.thePrice,
          webTheoryRatio: direction == 'B'?obj.salePercent : obj.buyPercent,
          webVolatility:  direction == 'B'?obj.buyVol : obj.saleVol,
          contractValue: this.mul(obj.volume, obj.thePrice),
          contractUnit: '',
          tradePassword: this.tradePassword,
        }
        axios.post('trade/clientorder/doAdd.do', this.qs.stringify(data)).then(result => {
          if(result.data.success) {
            this.$Message.success('下单请求已成功发送')
            this.handlerClose()
          }
        })
      },
      prompt: function () {
        this.modalPrompt = true
      },
      loginSys: function () {
        this.drawerBtn = false
        if (this.username == "请登录") {
          this.$router.push('/login')
        }
      },
      //  计算最新价格
      getNewPriceFun: function () { 
        if(!this.dayDiff) {
          this.getDiff().then(day => {
            this.dayDiff = day
            this.getNewPriceFun()
          })
        } else {
          for (let a = 0; a < this.newData.length; a++) {
            for(let j = 0; j < this.CacheData.length; j++) {
              if(this.newData[a].market == this.CacheData[j].exchange_id && this.newData[a].code == this.CacheData[j].instrument_id) {
                if (this.CacheData.length !== 0) {
                  if (this.newData[a].price !== '') {
                    if (this.newData[a].price < this.CacheData[j].pre_settlement_price) {
                      this.newData[a].call = false
                      this.newData[a].put = false
                    } else if (this.newData[a].price > this.CacheData[j].pre_settlement_price) {
                      this.newData[a].call = true
                      this.newData[a].put = false
                    } else if(this.newData[a].price == this.CacheData[j].pre_settlement_price) {
                      this.newData[a].put = true
                    }
                  }
                  if (!this.CacheData[j]) {
                    return
                  }
                  if(this.newData[a].yearSession == 365 || this.newData[a].yearSession == 0) {
                    var dateNum = this.DateDiff(this.nowDate, this.changeDate(this.expiryDate), this.newData[a].buyCpsDays, this.newData[a].sellCpsDays)
                  } else {
                    if(!this.dayDiff) {
                      this.getDiff().then(day => {
                        var dateNum = [day + this.newData[a].buyCpsDays, day + this.newData[a].sellCpsDays]
                      })
                    } else {
                      var dateNum = [this.dayDiff + this.newData[a].buyCpsDays, this.dayDiff + this.newData[a].sellCpsDays]
                    }
                  }
                  // let dateNum = this.DateDiff(this.nowDate, this.changeDate(this.expiryDate), this.newData[a].buyCpsDays,
                  //   this.newData[a].sellCpsDays)
                  if(!dateNum) dateNum = [0,0]
                  let bidDeduction = this.bid_deduction
                  let askDeduction = this.ask_deduction 
                  
                  if(this.newData[a].yearSession == 365 || this.newData[a].yearSession == 0) {
                    var dtBuy = this.division(this.sub(dateNum[0], bidDeduction), 365)
                    var dtSale = this.division(this.sub(dateNum[1], askDeduction), 365)
                  } else {
                    var dtBuy =  this.division(dateNum[0], this.newData[a].yearSession)
                    var dtSale =  this.division(dateNum[1], this.newData[a].yearSession)
                  }
                  let priceAccuracy = this.newData[a].priceAccuracy
                  this.newData[a].price = Number(this.CacheData[j].last_price.toFixed(priceAccuracy))
                  if (this.newData[a].bid_volatility !== 0 && this.newData[a].price !== 0) {
                    this.newData[a].sale = this.CalcCall(this.newData[a].price, this.newData[a].bid_volatility, this.newData[a].interest_rate, this.newData[a].price, dtBuy)
                    this.newData[a].buy = this.CalcCall(this.newData[a].price, this.newData[a].ask_volatility, this.newData[a].interest_rate, this.newData[a].price, dtSale)
                    if (this.buyLabel === '买价') {
                      this.newData[a].sale = this.newData[a].sale.toFixed(priceAccuracy)
                      this.newData[a].buy = this.newData[a].buy.toFixed(priceAccuracy)
                    } else if (this.buyLabel === '买价%') {
                      this.newData[a].buy = this.mul( this.division(this.newData[a].buy, this.newData[a].price), 100).toFixed(3) + '%'
                      this.newData[a].sale = this.mul( this.division(this.newData[a].sale, this.newData[a].price), 100).toFixed(3) + '%'
                    } else {
                      // this.newData[a].buy = (this.newData[a].bid_volatility * 100).toFixed(2) + '%'
                      // this.newData[a].sale = (this.newData[a].ask_volatility * 100).toFixed(2) + '%'
                      this.newData[a].buy = (this.newData[a].ask_volatility * 100).toFixed(3) + '%'
                      this.newData[a].sale = (this.newData[a].bid_volatility * 100).toFixed(3) + '%'
                    }
                  } else {
                    this.newData[a].buy = '---'
                    this.newData[a].sale = '---'
                  }
                } else {
                  this.newData[a].price = 0
                  this.newData[a].buy = '---'
                  this.newData[a].sale = '---'
                }
              }
            }
            
          }
        }
        
      },
      //  切换报价模式
      priceTypeChange: function () {
        switch (this.buyLabel) {
          case '买价':
            this.buyLabel = '买价%'
            this.saleLabel = '卖价%'
            for (var i = 0; i < this.newData.length; i++) {
              this.newData[i].buy = this.mul(this.division(this.newData[i].buy, this.newData[i].price), 100).toFixed(3) + '%'
              this.newData[i].sale = this.mul(this.division(this.newData[i].sale, this.newData[i].price), 100).toFixed(3) + '%'
            }
            this.$Message.info({
              content: '百分比报价',
              duration: 1
            })
            break
          case '买价%':
            this.buyLabel = '买价vol'
            this.saleLabel = '卖价vol'
            for (var j = 0; j < this.newData.length; j++) {
              // this.newData[j].buy = (this.newData[j].bid_volatility * 100).toFixed(2) + '%'
              // this.newData[j].sale = (this.newData[j].ask_volatility * 100).toFixed(2) + '%'
              if(this.newData[j].price == '---' || !this.newData[j].price) return
              this.newData[j].buy = this.newData[j].ask_volatility > 0 ? this.mul(this.newData[j].ask_volatility, 100).toFixed(3) + '%' : '---'
              this.newData[j].sale = this.newData[j].ask_volatility > 0 ? this.mul(this.newData[j].bid_volatility, 100).toFixed(3) + '%' : '---'
            }
            this.$Message.info({
              content: '波动度报价',
              duration: 1
            })
            break
          case '买价vol':
            this.buyLabel = '买价'
            this.saleLabel = '卖价'
            this.getNewPriceFun()
            break
        }
      },
      read() {
        let _this = this
        let xhr = new XMLHttpRequest()
        xhr.open("GET", "RiskDisclosure.txt")
        xhr.setRequestHeader("contentType", "application/x-www-form-urlencoded; charset=utf-8")
        xhr.send()
        xhr.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            _this.book = xhr.responseText
            window.localStorage.setItem("stateus", '1')
          }
        }
        this.dialogVisible = true
      },
      getCurrentDate() {
        return new Promise((reslove, reject) => {
          axios.get('client/inner/businessinfo/query.do').then(result => {
            let nowDate = this.dateFormat(result.data.businessInfo.tradingDay)
            reslove(nowDate)
            // window.sessionStorage('nowDate', this.nowDate)
          })
        })  
        
      },
      getDiff(start = this.nowDate, end = this.expiryDate, isTrade = 1) {
        return new Promise((reslove, reject) => {
          axios.post('client/forward/forwardorderlog/getDaysByTradingDayType.do', this.qs.stringify({
            staringDate: start,
            expiringDate: end,
            tradingDayType: isTrade,
          })).then(result => {
            reslove(result.data.days)
            return result.data.days
          })
        })
      },
      changeVarietyName(obj) {
        let str = ''
        this.nameOptions.forEach(item => {
          if (item.product.toLowerCase() == obj.name.toLowerCase() && item.exchange.toLowerCase() == obj.market
            .toLowerCase()) {
            str = item.instrumentName
          }
        })
        if (str) {
          return str
        } else {
          return '---'
        }
      },
      enter() {
        axios.post("clientbind/checkTradePassword.do", this.qs.stringify({
          clientBindId: this.userId,
          tradePassword: this.encryption(this.tradePassword)
        })).then(result => {
          if(result.data.success) {
            window.sessionStorage.setItem('tradePassword', true)
            this.handlerClose()
            this.optionOrder()
          }
        })
      },
      lessThan(num, row){      //为负数和NaN不进行报价显示--
        if(num.toString() == "NaN" || num == 'NaN%') {
          return '---'
        } else if(parseFloat(num) <= 0){
          return '---'
        } else {
          return num
        }
      },
      handlerClose() {
        this.dialogOrder = false
      },
      openPassDialog() {
        this.tradePassword = ''
      },

      setServerOptional() {     //登录的情况下将本地自选信息添加到服务器中
        let params = JSON.parse(window.localStorage.getItem("optionalCode"))
        if(!params || !params.length) return
        axios.post('client/addSelfSelectionList.do', params).then(result => {
          if (result.success) {
              // this.$Message.info('添加自选成功')
              window.localStorage.removeItem("optionalCode")
            } 
        })
      },
    },
    watch: {
      $route(to, from) {
        if (to.name == "Home") {
          this.drawerModal = false
          let login = window.sessionStorage.getItem("login")
          if (login) {
            this.getInfo()
          }
        } else {
          clearInterval(this.fluctuationTimer)
          this.fluctuationTimer = null
        }
      },
      // expiryDate(newValue, oldValue) {
      //   if (newValue.toString().length > 10) {
      //     this.expiryDate = this.changeDate(newValue)
      //   }
      //   if(newValue != this.expiryDate) {
      //     let day = this.getDiff(this.nowDate, this.expiryDate).then(day => {
      //       this.dayDiff = [day, day]
      //     })  
          
      //   }
      // },
      expiryDate: {
        handler(newValue, oldValue) {
          if(newValue.toString().length > 10) {
            this.expiryDate = this.changeDate(newValue)
          }
          if(newValue != this.expiryDate && newValue) {
            window.sessionStorage.setItem("expiryDate", this.expiryDate)
            this.getDiff(this.nowDate, this.expiryDate).then(day => {
              this.dayDiff = day
              window.sessionStorage.setItem("dayDiff", day)
            })
          }

        },
        immediate: true
      },
      nowDate(newValue, oldValue) {
        if(newValue != oldValue && this.expiryDate) {
          let day = this.getDiff(this.nowDate, this.expiryDate).then(day => {
            this.dayDiff = day
          })
        }
      }
    },
    computed: {
      username() {
        return this.$store.state.username
      },
      baseurl() {
        return this.$store.state.baseurl
      },
      gsName() {
        return global_.companyName
      },
      userID() {
        return this.$store.state.userID
      },
      headClass() {
        let sys = global_.system
        if(sys == '') {
          return 'production-color'
        } else if(sys == '仿真环境') {
          return 'emulator-color'
        } else {
          return 'other-color'
        }
      },
      sys() {
        return global_.system
      },
    }
  }
</script>